import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiHeaderFooterBundle } from '../shared';
import { Paginator as PaginatorBase } from 'prime-ng-old/paginator';
import { AngleDoubleLeftIcon } from 'prime-ng-old/icons/angledoubleleft';
import { AngleDoubleRightIcon } from 'prime-ng-old/icons/angledoubleright';
import { AngleLeftIcon } from 'prime-ng-old/icons/angleleft';
import { AngleRightIcon } from 'prime-ng-old/icons/angleright';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../input-dropdown/input-dropdown";
import * as i3 from "@angular/forms";
const _c0 = a0 => ({
  "p-disabled": a0
});
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = a0 => ({
  "p-highlight": a0
});
function UiPaginatorComponent_Conditional_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "start");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.templateLeft)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c1, ctx_r1.paginatorState));
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.currentPageReport);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleDoubleLeftIcon", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-paginator-icon");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_1_ng_template_0_Template(rf, ctx) {}
function UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_1_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.firstPageLinkIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function UiPaginatorComponent_Conditional_0_Conditional_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changePageToFirst($event));
    });
    i0.ɵɵconditionalCreate(1, UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_1_Template, 1, 1, "AngleDoubleLeftIcon", 6);
    i0.ɵɵconditionalCreate(2, UiPaginatorComponent_Conditional_0_Conditional_3_Conditional_2_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.isFirstPage() || ctx_r1.empty())("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx_r1.isFirstPage() || ctx_r1.empty()));
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel("firstPageLabel"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.firstPageLinkIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.firstPageLinkIconTemplate ? 2 : -1);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleLeftIcon", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-paginator-icon");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_6_1_ng_template_0_Template(rf, ctx) {}
function UiPaginatorComponent_Conditional_0_Conditional_6_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_6_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_6_1_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.previousPageLinkIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_7_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function UiPaginatorComponent_Conditional_0_Conditional_7_For_2_Template_button_click_0_listener($event) {
      const pageLink_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onPageLinkClick($event, pageLink_r5 - 1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageLink_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2, pageLink_r5 - 1 == ctx_r1.getPage()));
    i0.ɵɵattribute("aria-label", ctx_r1.getPageAriaLabel(pageLink_r5))("aria-current", pageLink_r5 - 1 == ctx_r1.getPage() ? "page" : undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getLocalization(pageLink_r5), " ");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵrepeaterCreate(1, UiPaginatorComponent_Conditional_0_Conditional_7_For_2_Template, 2, 6, "button", 18, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.pageLinks);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_8_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r1.currentPageReport);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dropdownIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_ng_template_0_Template, 1, 1, "ng-template", 22);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-input-dropdown", 20);
    i0.ɵɵlistener("onChange", function UiPaginatorComponent_Conditional_0_Conditional_8_Template_ui_input_dropdown_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPageDropdownChange($event));
    });
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_8_ng_template_1_Template, 1, 1, "ng-template", 21);
    i0.ɵɵconditionalCreate(2, UiPaginatorComponent_Conditional_0_Conditional_8_Conditional_2_Template, 1, 0, null, 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("options", ctx_r1.pageItems)("ngModel", ctx_r1.getPage())("disabled", ctx_r1.empty())("appendTo", ctx_r1.dropdownAppendTo)("scrollHeight", ctx_r1.dropdownScrollHeight);
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel("jumpToPageDropdownLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.dropdownIconTemplate ? 2 : -1);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleRightIcon", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-paginator-icon");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_11_1_ng_template_0_Template(rf, ctx) {}
function UiPaginatorComponent_Conditional_0_Conditional_11_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_11_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_11_1_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.nextPageLinkIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleDoubleRightIcon", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-paginator-icon");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_1_ng_template_0_Template(rf, ctx) {}
function UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_1_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.lastPageLinkIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function UiPaginatorComponent_Conditional_0_Conditional_12_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changePageToLast($event));
    });
    i0.ɵɵconditionalCreate(1, UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_1_Template, 1, 1, "AngleDoubleRightIcon", 6);
    i0.ɵɵconditionalCreate(2, UiPaginatorComponent_Conditional_0_Conditional_12_Conditional_2_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.isLastPage() || ctx_r1.empty())("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx_r1.isLastPage() || ctx_r1.empty()));
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel("lastPageLabel"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.lastPageLinkIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.lastPageLinkIconTemplate ? 2 : -1);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inputNumber", 24);
    i0.ɵɵlistener("ngModelChange", function UiPaginatorComponent_Conditional_0_Conditional_13_Template_p_inputNumber_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changePage($event - 1));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngModel", ctx_r1.currentPage())("disabled", ctx_r1.empty());
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dropdownItemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, item_r10));
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_ng_template_0_Template, 1, 4, "ng-template", 26);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dropdownIconTemplate);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_ng_template_0_Template, 1, 1, "ng-template", 22);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-input-dropdown", 25);
    i0.ɵɵlistener("ngModelChange", function UiPaginatorComponent_Conditional_0_Conditional_14_Template_ui_input_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.rows = $event);
    })("onChange", function UiPaginatorComponent_Conditional_0_Conditional_14_Template_ui_input_dropdown_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRppChange($event));
    });
    i0.ɵɵconditionalCreate(1, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_1_Template, 1, 0, null, 26);
    i0.ɵɵconditionalCreate(2, UiPaginatorComponent_Conditional_0_Conditional_14_Conditional_2_Template, 1, 0, null, 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("options", ctx_r1.rowsPerPageItems)("ngModel", ctx_r1.rows)("disabled", ctx_r1.empty())("appendTo", ctx_r1.dropdownAppendTo)("scrollHeight", ctx_r1.dropdownScrollHeight)("ariaLabel", ctx_r1.getAriaLabel("rowsPerPageLabel"))("placeholder", false);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.dropdownItemTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.dropdownIconTemplate ? 2 : -1);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_15_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiPaginatorComponent_Conditional_0_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, UiPaginatorComponent_Conditional_0_Conditional_15_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "end");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.templateRight)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c1, ctx_r1.paginatorState));
  }
}
function UiPaginatorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵconditionalCreate(1, UiPaginatorComponent_Conditional_0_Conditional_1_Template, 2, 5, "div", 2);
    i0.ɵɵconditionalCreate(2, UiPaginatorComponent_Conditional_0_Conditional_2_Template, 2, 1, "span", 3);
    i0.ɵɵconditionalCreate(3, UiPaginatorComponent_Conditional_0_Conditional_3_Template, 3, 7, "button", 4);
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵlistener("click", function UiPaginatorComponent_Conditional_0_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changePageToPrev($event));
    });
    i0.ɵɵconditionalCreate(5, UiPaginatorComponent_Conditional_0_Conditional_5_Template, 1, 1, "AngleLeftIcon", 6);
    i0.ɵɵconditionalCreate(6, UiPaginatorComponent_Conditional_0_Conditional_6_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(7, UiPaginatorComponent_Conditional_0_Conditional_7_Template, 3, 0, "span", 8);
    i0.ɵɵconditionalCreate(8, UiPaginatorComponent_Conditional_0_Conditional_8_Template, 3, 7, "ui-input-dropdown", 9);
    i0.ɵɵelementStart(9, "button", 10);
    i0.ɵɵlistener("click", function UiPaginatorComponent_Conditional_0_Template_button_click_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changePageToNext($event));
    });
    i0.ɵɵconditionalCreate(10, UiPaginatorComponent_Conditional_0_Conditional_10_Template, 1, 1, "AngleRightIcon", 6);
    i0.ɵɵconditionalCreate(11, UiPaginatorComponent_Conditional_0_Conditional_11_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(12, UiPaginatorComponent_Conditional_0_Conditional_12_Template, 3, 7, "button", 11);
    i0.ɵɵconditionalCreate(13, UiPaginatorComponent_Conditional_0_Conditional_13_Template, 1, 2, "p-inputNumber", 12);
    i0.ɵɵconditionalCreate(14, UiPaginatorComponent_Conditional_0_Conditional_14_Template, 3, 9, "ui-input-dropdown", 13);
    i0.ɵɵconditionalCreate(15, UiPaginatorComponent_Conditional_0_Conditional_15_Template, 2, 5, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngStyle", ctx_r1.style)("ngClass", "p-paginator p-component");
    i0.ɵɵattribute("data-pc-section", "paginator")("data-pc-section", "root");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.templateLeft ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showCurrentPageReport ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showFirstLastIcon ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isFirstPage() || ctx_r1.empty())("ngClass", i0.ɵɵpureFunction1(25, _c0, ctx_r1.isFirstPage() || ctx_r1.empty()));
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel("prevPageLabel"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.previousPageLinkIconTemplate ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.previousPageLinkIconTemplate ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showPageLinks ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showJumpToPageDropdown ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.isLastPage() || ctx_r1.empty())("ngClass", i0.ɵɵpureFunction1(27, _c0, ctx_r1.isLastPage() || ctx_r1.empty()));
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel("nextPageLabel"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.nextPageLinkIconTemplate ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.nextPageLinkIconTemplate ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showFirstLastIcon ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showJumpToPageInput ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.rowsPerPageOptions ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.templateRight ? 15 : -1);
  }
}
export let UiPaginatorComponent = /*#__PURE__*/(() => {
  class UiPaginatorComponent extends PaginatorBase {
    constructor() {
      super(...arguments);
      this.currentPageReportTemplate = "Zeige Items {first} bis {last}, insgesamt {totalRecords}";
    }
    setPage(index) {
      console.log('update paginator page to ' + index);
      this.first = index * this.rows;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiPaginatorComponent_BaseFactory;
        return function UiPaginatorComponent_Factory(__ngFactoryType__) {
          return (ɵUiPaginatorComponent_BaseFactory || (ɵUiPaginatorComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiPaginatorComponent)))(__ngFactoryType__ || UiPaginatorComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiPaginatorComponent,
        selectors: [["ui-paginator"]],
        inputs: {
          currentPageReportTemplate: "currentPageReportTemplate"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "class", "ngStyle", "ngClass"], [3, "ngStyle", "ngClass"], [1, "p-paginator-left-content"], [1, "p-paginator-current"], ["type", "button", "pRipple", "", 1, "p-paginator-first", "p-paginator-element", "p-link", 3, "disabled", "ngClass"], ["type", "button", "pRipple", "", 1, "p-paginator-prev", "p-paginator-element", "p-link", 3, "click", "disabled", "ngClass"], [3, "styleClass"], [1, "p-paginator-icon"], [1, "p-paginator-pages"], ["styleClass", "p-paginator-page-options", 3, "options", "ngModel", "disabled", "appendTo", "scrollHeight"], ["type", "button", "pRipple", "", 1, "p-paginator-next", "p-paginator-element", "p-link", 3, "click", "disabled", "ngClass"], ["type", "button", "pRipple", "", 1, "p-paginator-last", "p-paginator-element", "p-link", 3, "disabled", "ngClass"], [1, "p-paginator-page-input", 3, "ngModel", "disabled"], ["styleClass", "p-paginator-rpp-options", 3, "options", "ngModel", "disabled", "appendTo", "scrollHeight", "ariaLabel", "placeholder"], [1, "p-paginator-right-content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "pRipple", "", 1, "p-paginator-first", "p-paginator-element", "p-link", 3, "click", "disabled", "ngClass"], [4, "ngTemplateOutlet"], ["type", "button", "pRipple", "", 1, "p-paginator-page", "p-paginator-element", "p-link", 3, "ngClass"], ["type", "button", "pRipple", "", 1, "p-paginator-page", "p-paginator-element", "p-link", 3, "click", "ngClass"], ["styleClass", "p-paginator-page-options", 3, "onChange", "options", "ngModel", "disabled", "appendTo", "scrollHeight"], ["pTemplate", "selectedItem"], ["pTemplate", "dropdownicon"], ["type", "button", "pRipple", "", 1, "p-paginator-last", "p-paginator-element", "p-link", 3, "click", "disabled", "ngClass"], [1, "p-paginator-page-input", 3, "ngModelChange", "ngModel", "disabled"], ["styleClass", "p-paginator-rpp-options", 3, "ngModelChange", "onChange", "options", "ngModel", "disabled", "appendTo", "scrollHeight", "ariaLabel", "placeholder"], ["pTemplate", "item"]],
        template: function UiPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiPaginatorComponent_Conditional_0_Template, 16, 29, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional((ctx.alwaysShow ? true : ctx.pageLinks && ctx.pageLinks.length > 1) ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, i2.UiInputDropdownComponent, FormsModule, i3.NgControlStatus, i3.NgModel, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleLeftIcon, AngleRightIcon],
        styles: ["@layer primeng{.p-paginator[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}.p-paginator-left-content[_ngcontent-%COMP%]{margin-right:auto}.p-paginator-right-content[_ngcontent-%COMP%]{margin-left:auto}.p-paginator-page[_ngcontent-%COMP%], .p-paginator-next[_ngcontent-%COMP%], .p-paginator-last[_ngcontent-%COMP%], .p-paginator-first[_ngcontent-%COMP%], .p-paginator-prev[_ngcontent-%COMP%], .p-paginator-current[_ngcontent-%COMP%]{cursor:pointer;display:inline-flex;align-items:center;justify-content:center;line-height:1;-webkit-user-select:none;user-select:none;overflow:hidden;position:relative}.p-paginator-element[_ngcontent-%COMP%]:focus{z-index:1;position:relative}}.p-paginator[_ngcontent-%COMP%]{background-color:var(--paginatorBgColor);color:var(--paginatorTextColor);border:1px solid #c8c8c8;border-color:var(--paginatorBorderColor);padding:4px;position:relative}.p-paginator[_ngcontent-%COMP%]   .p-paginator-first[_ngcontent-%COMP%], .p-paginator[_ngcontent-%COMP%]   .p-paginator-prev[_ngcontent-%COMP%], .p-paginator[_ngcontent-%COMP%]   .p-paginator-next[_ngcontent-%COMP%], .p-paginator[_ngcontent-%COMP%]   .p-paginator-last[_ngcontent-%COMP%]{color:var(--paginatorIconColor);height:1.8em;min-width:1.8em;border:0 none;border-color:var(--paginatorElementBorderColor);line-height:1.8em;padding:0;margin:0;vertical-align:top}.p-paginator[_ngcontent-%COMP%]   .p-paginator-first[_ngcontent-%COMP%]:not(.p-disabled):not(.p-highlight):hover, .p-paginator[_ngcontent-%COMP%]   .p-paginator-prev[_ngcontent-%COMP%]:not(.p-disabled):not(.p-highlight):hover, .p-paginator[_ngcontent-%COMP%]   .p-paginator-next[_ngcontent-%COMP%]:not(.p-disabled):not(.p-highlight):hover, .p-paginator[_ngcontent-%COMP%]   .p-paginator-last[_ngcontent-%COMP%]:not(.p-disabled):not(.p-highlight):hover{background-color:var(--paginatorElementHoverBgColor);color:var(--paginatorElementHoverIconColor)}.p-paginator[_ngcontent-%COMP%]   .p-paginator-first[_ngcontent-%COMP%]:before{position:relative;top:1px}.p-paginator[_ngcontent-%COMP%]   .p-paginator-prev[_ngcontent-%COMP%]:before{position:relative}.p-paginator[_ngcontent-%COMP%]   .p-paginator-next[_ngcontent-%COMP%]:before{position:relative;top:1px}.p-paginator[_ngcontent-%COMP%]   .p-paginator-last[_ngcontent-%COMP%]:before{position:relative;top:1px}.p-paginator[_ngcontent-%COMP%]   .p-paginator-current[_ngcontent-%COMP%]{margin-left:1em;margin-right:1em;font-size:var(--fontSizeSmall);line-height:1.5;opacity:.5}.p-paginator[_ngcontent-%COMP%]   .p-paginator-pages[_ngcontent-%COMP%]{vertical-align:top;display:inline-block;padding:0}.p-paginator[_ngcontent-%COMP%]   .p-paginator-pages[_ngcontent-%COMP%]   .p-paginator-page[_ngcontent-%COMP%]{color:var(--paginatorIconColor);height:1.8em;min-width:1.8em;border:0 none;border-color:var(--paginatorElementBorderColor);border-radius:4px;line-height:1.8em;padding:0;margin:0;vertical-align:top}.p-paginator[_ngcontent-%COMP%]   .p-paginator-pages[_ngcontent-%COMP%]   .p-paginator-page.p-highlight[_ngcontent-%COMP%]{background-color:var(--paginatorActiveBgColor);color:var(--paginatorActiveTextColor)}.p-paginator[_ngcontent-%COMP%]   .p-paginator-pages[_ngcontent-%COMP%]   .p-paginator-page[_ngcontent-%COMP%]:not(.p-highlight):hover{background-color:var(--paginatorElementHoverBgColor);color:var(--paginatorElementHoverIconColor)}.p-paginator[_ngcontent-%COMP%]     .p-dropdown{margin-left:.5em;height:1.8em;min-width:60px}.p-paginator[_ngcontent-%COMP%]     .p-dropdown-label{height:1.8em;line-height:1.8em;padding-top:0;padding-bottom:0}@media screen and (min-width: 960px){.p-paginator[_ngcontent-%COMP%]   .p-paginator-current[_ngcontent-%COMP%]{position:absolute!important;right:0;top:8px;margin:0}}@media screen and (max-width: 959px){.p-paginator[_ngcontent-%COMP%]{padding-bottom:25px}.p-paginator[_ngcontent-%COMP%]   .p-paginator-current[_ngcontent-%COMP%]{position:absolute!important;bottom:0}}  .p-datatable .p-paginator{margin-top:15px}"],
        changeDetection: 0
      });
    }
  }
  return UiPaginatorComponent;
})();
export const UiPaginatorBundle = [UiPaginatorComponent, UiHeaderFooterBundle];